export default __webpack_public_path__ + "static/media/gamification-scratch.954bb755.png";